export const PortfolioData = [{
        id: 1,
        image: "assets/images/portfolyo/VolkanKiycak.webp",
        title: " Volkan Kıyçak",
    },
    {
        id: 2,
        image: "assets/images/portfolyo/AdminVolkanKiycak.webp",
        title: "Admin Volkan Kıyçak",
    },
    {
        id: 3,
        image: "assets/images/portfolyo/MeridyenTerapi.webp",
        title: "Meridyen Terapi",
    },
    {
        id: 4,
        image: "assets/images/portfolyo/DuyuAlgiMotor.webp",
        title: "Duyu Algı Motor"
    },
    {
        id: 5,
        image: "assets/images/portfolyo/Eticaret.webp",
        title: "E-ticaret",
    },
    {
        id: 6,
        image: "assets/images/portfolyo/TrendMagaza.webp",
        title: "Trend Mağaza",
    },
    {
        id: 7,
        image: "assets/images/portfolyo/PosApplication.webp",
        title: "Pos Application",
    },
     {
        id: 8,
        image: "assets/images/portfolyo/Food.webp",
        title: "Food",
    },
     {
        id: 9,
        image: "assets/images/portfolyo/Stanley.webp",
        title: "Stanley",
    },
     {
        id: 10,
        image: "assets/images/portfolyo/StartBootstrap.webp",
        title: "Start Bootstrap",
    },
     {
        id: 11,
        image: "assets/images/portfolyo/EmlakKatilim.webp",
        title: "Emlak Katılım",
    },
    {
        id: 12,
        image: "assets/images/portfolyo/MyPortfolio.webp",
        title: "My Portfolio",
    },
    {
        id: 13,
        image: "assets/images/portfolyo/FilmPlatformu.webp",
        title: "Film Platformu",
    }
]